<template>
  <div
    ref="chartWrapper"
    v-resize:debounce.500="resizeChart"
    :style="{width: width ? width + 'px' : '100%',height: height ? height + 'px' : '100%'}"
  >
    <div
      id="vueChart"
      ref="vueChart"
      style="width: 100%;height: 100%;"
    >
      {{ data }}
    </div>
  </div>
</template>

<script>
import resize from 'vue-resize-directive';
import chartConfig from './chart.config';

export default {
  name: 'PieChart',
  directives: {
    resize
  },
  props: {
    isFinished: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: () => {
        return null;
      }
    },
    height: {
      type: Number,
      default: () => {
        return null;
      }
    },
    labelLine: {
      type: Number,
      default: () => {
        return null;
      }
    },
    title: {
      type: String,
      default: ''
    },
    titleAlign: {
      type: String,
      default: ''
    },
    chartOpt: {
      required: false,
      type: Object,
      default: function () {
        return {};
      }
    },
    data: {
      required: false,
      type: Array,
      default: function () {
        return []; // [{value: 100, name: '数据例子格式'}]
      }
    },
    showLegend: {
      required: false,
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      vueChart: {},
      downLoadImg: null
    };
  },
  computed: {
    originData () {
      return this.data;
    },
    originChartOpt () {
      const that = this;
      const defaultOpt = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        toolbox: {
          show: true,
          top: that.title ? '22' : '0',
          right: '20',
          iconStyle: {
            borderColor: '#333'
          },
          feature: {
            // saveAsImage: {}
          }
        },
        legend: {
          show: that.showLegend,
          data: [],
          bottom: 0,
          itemWidth: 12
        },
        grid: {
          left: '30',
          right: '30',
          bottom: '30',
          containLabel: true
        },
        radius: '55%',
        label: {
          color: '#000',
          formatter: '{b}：{c}\n({d}%)'
        },
        labelLine: {
          show: true,
          length2: 6
        }
      };
      this.data.map(item => {
        if (item) {
          defaultOpt.legend.data.push(item.name);
        }
      });
      return this.$HMUtil.deepMerge(defaultOpt, this.chartOpt);
    },
    opt () {
      const that = this;
      const obj = {
        title: {
          text: that.title,
          x: that.titleAlign,
          textStyle: {
            color: '#001135',
            fontSize: 16,
            fontWeight: 'normal'
          }
        },
        color: chartConfig.color,
        toolbox: that.originChartOpt.toolbox,
        tooltip: that.originChartOpt.tooltip,
        legend: that.originChartOpt.legend,
        grid: that.originChartOpt.grid,
        series: [
          {
            name: that.title,
            data: that.originData,
            type: 'pie',
            radius: that.originChartOpt.radius,
            center: ['50%', '50%'],
            label: that.originChartOpt.label,
            labelLine: that.originChartOpt.labelLine
          }
        ]
      };
      return obj;
    }
  },
  methods: {
    setEchart () {
      const dom = this.$refs.vueChart;
      // this.vueChart = this.$echarts.init(dom, {
      //   width: 'auto',
      //   height: 'auto'
      // });
      this.vueChart = this.$echarts.init(dom);
      this.vueChart.setOption(this.opt);
      this.$refs.chartWrapper.addEventListener('resize', this.vueChart.resize);
      const that = this;
      this.vueChart.on('finished', function () {
        that.$emit('update:isFinished', true);
      });
    },
    resizeChart () {
      if (this.vueChart) {
        this.vueChart.resize();
      }
    },
    chartChange () {
      this.$emit('update:isFinished', false);
      this.vueChart.clear();
      this.vueChart.setOption(this.opt);
    },
    chartDownload () {
      const _href = this.vueChart.getDataURL({
        pixelRatio: 2,
        backgroundColor: '#fff'
      });
      this.$HMUtil.openForDownload(_href, this.title);
    },
    getBase64Img () {
      const base64Img = this.vueChart.getDataURL({
        pixelRatio: 2,
        backgroundColor: '#fff'
      });
      return base64Img.replace('data:image/png;base64,', '');
    }
  },
  mounted () {
    this.setEchart();
  },
  updated () {
    if (Object.keys(this.vueChart).length === 0) {
      this.setEchart();
    }
    this.chartChange();
  },
  beforeDestroy () {
    this.$emit('update:isFinished', false);
    this.$refs.chartWrapper.removeEventListener('resize', this.vueChart.resize);
  }
};
</script>
